var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventThumb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.197,
    height: 7.611,
    viewBox: "0 0 18.197 7.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32327",
    "data-name": "Group 32327",
    transform: "translate(-1453.599 -352.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M-465.54,508.721h-4.16a.756.756,0,0,1-.756-.756v-1.513a.757.757,0,0,1,.756-.756h4.16",
    transform: "translate(1924.455 -148.914)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M-437.456,505.7h4.16a.756.756,0,0,1,.756.756v1.513a.756.756,0,0,1-.756.756h-4.16",
    transform: "translate(1903.936 -148.914)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M-460.565,498.343l1.769-2a.375.375,0,0,0-.292-.646h-2.956a.375.375,0,0,0-.291.646Z",
    transform: "translate(1919.48 -142.696)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2665",
    "data-name": "Rectangle 2665",
    width: 8.076,
    height: 3.028,
    transform: "translate(1458.711 356.782)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M-440.565,498.343l1.769-2a.375.375,0,0,0-.292-.646h-2.956a.375.375,0,0,0-.291.646Z",
    transform: "translate(1907.043 -142.696)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventThumb);
export default __webpack_public_path__ + "static/media/event-thumb.a0decb65f9c8d67e9b1f75475320c228.svg";
export { ForwardRef as ReactComponent };